(function(){
document.documentElement.classList.add('ft-js');
function init(){
  var ft=document.querySelector('.ft'); if(!ft||ft.dataset.motionReady==='true') return;
  ft.dataset.motionReady='true';
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bar=document.createElement('div');bar.className='ft-progress';document.body.appendChild(bar);
  function prog(){var h=document.documentElement,m=h.scrollHeight-window.innerHeight;bar.style.transform='scaleX('+(m>0?window.scrollY/m:0)+')'}
  window.addEventListener('scroll',prog,{passive:true});
  window.addEventListener('pageshow',prog);prog();
  var shop=ft.querySelector('#shop');
  if(shop){var t=document.createElement('div');t.className='ft-ticker';t.setAttribute('aria-hidden','true');
    var s='<span>MORE THAN CLOTHES</span><span>CLOTHES FOR EVERYONE</span><span>WEAR IT YOUR WAY</span><span>THE TABLINE</span>';
    t.innerHTML='<div class="ft-track">'+s+s+s+s+'</div>';shop.parentNode.insertBefore(t,shop);}
  var hero=ft.querySelector('.hero .ph');
  if(hero&&window.matchMedia('(hover:hover)').matches){hero.addEventListener('mousemove',function(e){var r=hero.getBoundingClientRect();hero.style.setProperty('--mx',(e.clientX-r.left)+'px');hero.style.setProperty('--my',(e.clientY-r.top)+'px')})}
  if(reduce||!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:0,rootMargin:'40px 0px'});
  ft.querySelectorAll('.sig,.info,.look>*').forEach(function(el,i){
    el.classList.add('rv');
    if(el.classList.contains('card')){el.style.transitionDelay=((i%4)*70)+'ms'}
    io.observe(el);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();